export const formFields = Object.freeze({
  EMPLOYER: 'employer' as const,
  DATE_CANDIDATE_APPROVED: 'dateCandidateApproved' as const,
  DATE_COMPANY_APPROVED: 'dateCompanyApproved' as const,
  DATE_OF_INTERVIEW: 'dateOfInterview' as const,
  VACANCY_ID: 'vacancyId' as const,
  DATE_OF_INTRODUCTION: 'introductionDate' as const,
});
